import { MicrophoneMessageIcon } from './MicrophoneMessageIcon';

/**
 * author: Austin Andrews
 * id 5B1FA77D-0384-4931-AFD8-C4FF5D73D372
 * name microphone-message
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microphone-message.svg
 * tags
 */
export const TextToSpeechIcon = MicrophoneMessageIcon;
export default TextToSpeechIcon